'use client'

import { Dash } from '@/ui/atoms/dash/Dash'
import { Tooltip, TooltipContentLong, TooltipProvider, TooltipTrigger } from '@/ui/atoms/tooltip/Tooltip'
import type { YieldSource } from '../types'

interface UtilizationCellProps {
  utilization: number | undefined
  source?: YieldSource
}

function getNoUtilizationInfo(source?: YieldSource): { label: string; description: string } {
  switch (source) {
    case 'evault':
      return {
        label: 'Not Available',
        description:
          'Utilization data requires strategy information which is not available in fallback mode. Check back when the indexer is online.',
      }
    default:
      return {
        label: 'Not Available',
        description: 'Utilization data is not available for this opportunity.',
      }
  }
}

export function UtilizationCell({ utilization, source }: UtilizationCellProps) {
  // If utilization is a valid number (including 0), show it
  if (utilization !== undefined) {
    return <span className="font-medium text-foreground text-sm">{(utilization * 100).toFixed(1)}%</span>
  }

  // Otherwise show indicator that data is not available
  const { label, description } = getNoUtilizationInfo(source)

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild onClick={(e) => e.stopPropagation()}>
          <div className="flex cursor-pointer items-center justify-center">
            <Dash />
          </div>
        </TooltipTrigger>
        <TooltipContentLong>
          <div className="min-w-[200px] max-w-[280px] space-y-1 text-sm">
            <p className="font-medium">{label}</p>
            <p className="text-muted-foreground">{description}</p>
          </div>
        </TooltipContentLong>
      </Tooltip>
    </TooltipProvider>
  )
}
